import { render, staticRenderFns } from "./SpecialQuestions.vue?vue&type=template&id=f0574dd8&scoped=true"
import script from "./SpecialQuestions.vue?vue&type=script&lang=js"
export * from "./SpecialQuestions.vue?vue&type=script&lang=js"
import style0 from "./SpecialQuestions.vue?vue&type=style&index=0&id=f0574dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0574dd8",
  null
  
)

export default component.exports